import { useContext } from 'react';
import PatientContext from "../../store/patient-context";
import AuthContext from '../../store/auth-context';
import {Row, Col}  from 'react-bootstrap';
import MainNavigation from "./MainNavigation";

const NavigationHeader = (props) => {
  const authCtx = useContext(AuthContext);
  const patientCtx = useContext(PatientContext);

  return (
      <Row style={{justifyContent: "space-between"}}>
        <Col xs={"auto"} style={{display: "flex", justifyContent:"start", alignItems: "center"}}>
          <div style={{display: "flex", alignItems: "center"}}>
            <span className={"me-4"}>
              <img className={"NavBar-logo"} src="/images/UNLTDTherap Logo Symbol Medium.png" alt="Unlimited therapy logo" height={72}/>
            </span>
            <span>
              <div>
                <label>User</label> {authCtx.userFullName}
              </div>
              <div>
                <label>Patient</label> {patientCtx.patientFullName}
              </div>
            </span>
          </div>
        </Col>

        <Col xs={"auto"}>
          <MainNavigation/>
        </Col>
      </Row>
  );
}

export default NavigationHeader;
